import React, { useState, useEffect, useContext } from "react";
import "./NuevoMarca.css";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";
import { MarcasService } from "../../services/MarcasService";
import { AuthContext } from "../../context/AuthContext";
import { getBaseUrl } from "../../config/api";

const ActualizarMarca = () => {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const baseUrl = getBaseUrl();
  const [form, setForm] = useState({ descripcion: "", estado: "ACTIVO" });
  const [imagen, setImagen] = useState(null);
  const [preview, setPreview] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [errores, setErrores] = useState({});

  useEffect(() => {
    const fetchMarca = async () => {
      setLoading(true);
      try {
        const marcaData = await MarcasService.fetchMarcaPorId({ token, id });
        setForm({ descripcion: marcaData.descripcion, estado: marcaData.estado });
        if (marcaData.imagen) {
          setCurrentImage(marcaData.imagen);
          setPreview(null);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        if (error.response?.status === 404) {
          navigate("/admin/marcas");
          return;
        }
        console.error("Error al obtener la marca:", error);
      }
    };
    if (id) fetchMarca();
  }, [id, token, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImagen(file);
      setCurrentImage(null);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBackToList = () => {
    navigate("/admin/marcas");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errores = validarFormulario();
    if (Object.keys(errores).length > 0) {
      setErrores(errores);
      setError("");
      return;
    }
    setLoading(true);
    try {
      await MarcasService.editarMarca({ token, id, form, imagen });
      toast.success("Marca actualizada correctamente");
      navigate("/admin/marcas");
    } catch (err) {
      if (err.response?.status === 409) {
        toast.error(err.response.data.error);
      } else {
        toast.error("Error al actualizar la marca.");
      }
    } finally {
      setLoading(false);
    }
  };

  const validarFormulario = () => {
    const errores = {};
    if (!form.descripcion.trim()) {
      errores.descripcion = "La descripción es obligatoria";
    }
    return errores;
  };

  return (
    <div className="ventas-admin-content">
      {loading && <Preloader />}
      <div className="breadcrumb-container">
        <button type="button" className="breadcrumb-link" onClick={handleBackToList} style={{ background: "none", border: "none", padding: 0, cursor: "pointer", color: "var(--color-primary)", textDecoration: "underline", font: "inherit" }}>
          {"\u2190"} Listado de Marcas
        </button>
        <span className="breadcrumb-current"> / Actualizar Marca</span>
      </div>
      <div className="dashboard-card nuevo-producto-card">
        <span className="nueva-venta-title">Actualizar Marca</span>
        {error && <div className="error-message">{error}</div>}
        <form className="nuevo-producto-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <h3 className="section-title">Información de la Marca</h3>
            <div className="form-grid">
              <div className="form-group large">
                <label htmlFor="descripcion">Descripción *</label>
                <input
                  type="text"
                  name="descripcion"
                  value={form.descripcion}
                  onChange={handleChange}
                />
                {errores.descripcion && <span className="error">{errores.descripcion}</span>}
              </div>
              <div className="form-group">
                <label htmlFor="estado">Estado *</label>
                <select name="estado" value={form.estado} onChange={handleChange}>
                  <option value="ACTIVO">ACTIVO</option>
                  <option value="INACTIVO">INACTIVO</option>
                </select>
                {errores.estado && <span className="error">{errores.estado}</span>}
              </div>
              <div className="form-group large">
                <label htmlFor="imagen">Imagen de la Marca</label>
                <div className="image-upload-container">
                  <input
                    type="file"
                    name="imagen"
                    id="imagen"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="image-upload-input"
                  />
                  {preview && !currentImage && (
                    <div className="image-preview-logo">
                      <img src={preview} alt="Preview" />
                      <button
                        className="image-remove-btn"
                        onClick={() => {
                          setPreview(null);
                          setImagen(null);
                        }}
                      >
                        ×
                      </button>
                    </div>
                  )}
                  {!preview && (
                    <div className="image-placeholder">
                      {currentImage ? (
                        <img src={`${baseUrl}/uploads/${currentImage}`} alt="Marca actual" />
                      ) : (
                        <span>Sin imagen</span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="form-actions">
            <button className="btn btn-secondary" type="button" onClick={handleBackToList}>
              Cancelar
            </button>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? "Actualizando..." : "Actualizar Marca"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ActualizarMarca;
